/* The site's footer. Moved verbatim from player/src/App.tsx; the launcher
   passes the site origin and opens links externally. */
import { Clock } from './Icons'

export function SiteFooter({ origin = '', external = false, lastSweep, logoSrc = '/logo.svg' }: {
  origin?: string; external?: boolean; lastSweep: string | null | undefined; logoSrc?: string
}) {
  const ext = external ? { target: '_blank', rel: 'noopener noreferrer' } : {}
  return (
    <footer className="mono text-[11px] text-[var(--muted)] mt-4 pt-4 border-t border-[var(--border)]">
      <div className="flex justify-between items-center flex-wrap gap-2">
        <span className="flex items-center gap-2.5">
          <img src={logoSrc} alt="" aria-hidden="true" style={{ height: 36, width: 'auto', display: 'block' }} />
          <span>live DayZ server intelligence</span>
        </span>
        <span className="flex items-center gap-3">
          <a href={`${origin}/support`} {...ext} className="hover:text-[var(--foreground)]">Support</a>
          <a href={`${origin}/privacy`} {...ext} className="hover:text-[var(--foreground)]">Privacy</a>
          <a href={`${origin}/terms`} {...ext} className="hover:text-[var(--foreground)]">Terms</a>
          <span className="flex items-center gap-1"><Clock size={16} /> updated {lastSweep ? new Date(lastSweep).toLocaleTimeString() : '—'}</span>
        </span>
      </div>
      {/* Trademark courtesy: we use the DayZ name, so say plainly that we're a
          fan project. Standard non-affiliation wording, kept quiet on purpose. */}
      <p className="text-[10.5px] mt-3 leading-relaxed opacity-80">
        dayzmetrics is an unofficial fan project and is not affiliated with or endorsed by Bohemia
        Interactive a.s. DayZ and Bohemia Interactive are trademarks or registered trademarks of
        Bohemia Interactive a.s. All rights reserved.
      </p>
    </footer>
  )
}
